var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-timeline",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          closeEdit: _vm.initCurrentData,
          showEdit: _vm.setShowEdit,
          storeEdit: _vm.storeBlock,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "ol",
                    {
                      staticClass: "cw-timeline",
                    },
                    _vm._l(_vm.sortedItems, function (item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass: "cw-timeline-item",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cw-timeline-item-icon",
                              class:
                                "cw-timeline-item-icon-color-" + item.color,
                            },
                            [
                              _c("studip-icon", {
                                class: item.color,
                                attrs: {
                                  shape: item.icon,
                                  role: "info",
                                  size: "32",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-timeline-item-content",
                              class: [
                                index % 2 === 0 ? "left" : "right",
                                "cw-timeline-item-content-color-" + item.color,
                              ],
                            },
                            [
                              _vm.currentDateFormat !== "none"
                                ? _c("h3", [
                                    _vm._v(_vm._s(_vm.getItemDate(item))),
                                  ])
                                : _c("h3", [_vm._v(_vm._s(item.title))]),
                              _vm._v(" "),
                              _c("article", [
                                _vm.currentDateFormat !== "none"
                                  ? _c("header", [_vm._v(_vm._s(item.title))])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(item.description))]),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "col-2",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Zeitliche Sortierung")) +
                                  "\n                    "
                              ),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentSort,
                                      expression: "currentSort",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentSort = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "none",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$gettext("Keine")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "asc",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$gettext("Aufsteigend"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "desc",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$gettext("Absteigend")))]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "col-2",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Zeitangabe")) +
                                  "\n                    "
                              ),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentDateFormat,
                                      expression: "currentDateFormat",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentDateFormat = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "year",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$gettext("Jahr")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "date",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$gettext("Datum")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "time",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$gettext("Zeit")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "datetime",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$gettext("Datum und Zeit"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "none",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$gettext("Keine")))]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button add",
                          on: {
                            click: _vm.addItem,
                          },
                        },
                        [_vm._v(_vm._s(_vm.$gettext("Ereignis hinzufügen")))]
                      ),
                      _vm._v(" "),
                      _vm.currentItems.length > 0
                        ? _c(
                            "courseware-tabs",
                            {
                              attrs: {
                                setSelected: _vm.setItemTab,
                              },
                              on: {
                                selectTab: function selectTab($event) {
                                  _vm.setItemTab =
                                    parseInt(
                                      $event.name.replace(
                                        _vm.$gettext("Ereignis") + " ",
                                        ""
                                      )
                                    ) - 1
                                },
                              },
                            },
                            _vm._l(_vm.currentItems, function (item, index) {
                              return _c(
                                "courseware-tab",
                                {
                                  key: index,
                                  attrs: {
                                    index: index,
                                    name:
                                      _vm.$gettext("Ereignis") +
                                      " " +
                                      (index + 1).toString(),
                                    selected: index === 0,
                                    canBeEmpty: "",
                                  },
                                },
                                [
                                  _c(
                                    "form",
                                    {
                                      staticClass: "default",
                                      on: {
                                        submit: function submit($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-4",
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.$gettext("Titel")) +
                                              "\n                            "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.title,
                                                expression: "item.title",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                            },
                                            domProps: {
                                              value: item.title,
                                            },
                                            on: {
                                              input: function input($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "title",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-4",
                                        },
                                        [
                                          _vm._v(
                                            "\n\n                            " +
                                              _vm._s(
                                                _vm.$gettext("Beschreibung")
                                              ) +
                                              "\n                            "
                                          ),
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.description,
                                                expression: "item.description",
                                              },
                                            ],
                                            domProps: {
                                              value: item.description,
                                            },
                                            on: {
                                              input: function input($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "description",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-2",
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.$gettext("Farbe")) +
                                              "\n                            "
                                          ),
                                          _c("studip-select", {
                                            attrs: {
                                              options: _vm.colors,
                                              label: "name",
                                              clearable: false,
                                              reduce: function reduce(option) {
                                                return option.class
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "open-indicator",
                                                  fn: function fn(
                                                    selectAttributes
                                                  ) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._b(
                                                          {},
                                                          "span",
                                                          selectAttributes,
                                                          false
                                                        ),
                                                        [
                                                          _c("studip-icon", {
                                                            attrs: {
                                                              shape:
                                                                "arr_1down",
                                                              size: 10,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "no-options",
                                                  fn: function fn() {
                                                    return [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            _vm.$gettext(
                                                              "Es steht keine Auswahl zur Verfügung."
                                                            )
                                                          ) +
                                                          "\n                                "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "selected-option",
                                                  fn: function fn(option) {
                                                    return [
                                                      _c("span", {
                                                        staticClass:
                                                          "vs__option-color",
                                                        style: {
                                                          "background-color":
                                                            option.hex,
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(option.name)
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "option",
                                                  fn: function fn(option) {
                                                    return [
                                                      _c("span", {
                                                        staticClass:
                                                          "vs__option-color",
                                                        style: {
                                                          "background-color":
                                                            option.hex,
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(option.name)
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: item.color,
                                              callback: function callback($$v) {
                                                _vm.$set(item, "color", $$v)
                                              },
                                              expression: "item.color",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-2",
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.$gettext("Icon")) +
                                              "\n                            "
                                          ),
                                          _c("studip-select", {
                                            attrs: {
                                              options: _vm.icons,
                                              clearable: false,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "open-indicator",
                                                  fn: function fn(
                                                    selectAttributes
                                                  ) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._b(
                                                          {},
                                                          "span",
                                                          selectAttributes,
                                                          false
                                                        ),
                                                        [
                                                          _c("studip-icon", {
                                                            attrs: {
                                                              shape:
                                                                "arr_1down",
                                                              size: "10",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "no-options",
                                                  fn: function fn() {
                                                    return [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            _vm.$gettext(
                                                              "Es steht keine Auswahl zur Verfügung."
                                                            )
                                                          ) +
                                                          "\n                                "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "selected-option",
                                                  fn: function fn(option) {
                                                    return [
                                                      _c("studip-icon", {
                                                        attrs: {
                                                          shape: option.label,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "vs__option-with-icon",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(option.label)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "option",
                                                  fn: function fn(option) {
                                                    return [
                                                      _c("studip-icon", {
                                                        attrs: {
                                                          shape: option.label,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "vs__option-with-icon",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(option.label)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: item.icon,
                                              callback: function callback($$v) {
                                                _vm.$set(item, "icon", $$v)
                                              },
                                              expression: "item.icon",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-1",
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.$gettext("Datum")) +
                                              "\n                            "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.date,
                                                expression: "item.date",
                                              },
                                            ],
                                            attrs: {
                                              type: "date",
                                              required: "",
                                            },
                                            domProps: {
                                              value: item.date,
                                            },
                                            on: {
                                              input: function input($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "date",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-1",
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.$gettext("Zeit")) +
                                              "\n                            "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.time,
                                                expression: "item.time",
                                              },
                                            ],
                                            attrs: {
                                              type: "time",
                                            },
                                            domProps: {
                                              value: item.time,
                                            },
                                            on: {
                                              input: function input($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "time",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.currentItems.length > 1
                                        ? _c("label", [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "button trash",
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.removeItem(index)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.$gettext(
                                                        "Ereignis entfernen"
                                                      )
                                                    ) +
                                                    "\n                            "
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _vm._v(
                    _vm._s(_vm.$gettext("Informationen zum Zeitstrahl-Block"))
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }